import { useState } from 'react'
import { Loading } from '../../components/Loading/Loading'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { findNodeByType } from 'common/Prose/utils/findNodeByType'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { schema } from 'prose-core'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import Styles from './PollingPreview.module.scss'
import { StreamContentData } from './StreamContentData'
import { DESIGN_PATH } from 'paths'
import { useRouteMatch } from 'react-router-dom'
import { SuggestionRequestWithRequester } from 'types'
import cx from 'classnames'
import { PollSuggestionRequest } from './PollSuggestionRequest'
import { extractFirstCopy } from './utils'

interface Props {
  setImagesLoading: React.Dispatch<React.SetStateAction<boolean>>
  channel: ChannelType
  imagesLoading: boolean
}

const PollingPreview = observer(({ setImagesLoading, channel, imagesLoading }: Props) => {
  const [streamJobId, setStreamJobId] = useState<string>()
  const [streamContent, setStreamContent] = useState<string>('')
  const [request, setRequest] = useState<SuggestionRequestWithRequester>()
  const { docStore } = useRootStore()
  const view = useEditorView()

  const node = findNodeByType(view.state.doc, schema.nodes.ai_suggestion)
  const firstCopyStream = extractFirstCopy(streamContent, channel)

  const includesImages = !!request?.prompt.include_images
  if (!imagesLoading) setImagesLoading(includesImages && streamContent.includes('### Image options'))

  return (
    <>
      {docStore?.layerId && docStore?.articleId && node?.attrs.aiSuggestionRequestId && (
        <PollSuggestionRequest
          onStreaming={(jobId: string) => {
            if (jobId !== streamJobId) setStreamJobId(jobId)
          }}
          onRequestFetched={(request) => setRequest(request)}
          channel={channel}
          view={view}
          id={node.attrs.aiSuggestionRequestId}
          articleId={docStore.articleId}
          layerId={docStore.layerId}
          streamContent={streamContent}
        />
      )}
      {streamJobId && (
        <StreamContentData
          jobId={streamJobId}
          view={view}
          className={cx(Styles.prosePreview, Styles[channel])}
          setStreamContent={setStreamContent}
          streamContent={JSON.stringify(firstCopyStream)}
        />
      )}
      {!streamContent && <Loading />}
    </>
  )
})

const PollingPreviewContainer = (props: Props) => {
  const designRouteMatch = useRouteMatch(DESIGN_PATH)

  if (designRouteMatch) return null

  return <PollingPreview {...props} />
}

export { PollingPreviewContainer as PollingPreview }
